import { useEffect, useState } from 'react'

type RouteActions = typeof import('./routeActions')

let pending: Promise<RouteActions> | null = null

/** The route-action module, imported once on first use (see routeActions.ts). */
export function loadRouteActions(): Promise<RouteActions> {
  pending ??= import('./routeActions').catch((e: unknown) => {
    pending = null   // a failed chunk fetch may succeed on the next attempt
    throw e
  })
  return pending
}

/** The route-action module once loaded; null until then or if the load failed. */
export function useRouteActions(enabled: boolean): RouteActions | null {
  const [mod, setMod] = useState<RouteActions | null>(null)
  useEffect(() => {
    if (!enabled) return
    let live = true
    loadRouteActions().then(m => { if (live) setMod(m) }, () => { /* card keeps its neutral fallback */ })
    return () => { live = false }
  }, [enabled])
  return mod
}
